import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../../../Api/Index";
import { LANDING_PAGE_URL } from "../../../Common/Constant/Index";
const aboutUsPage = createAsyncThunk(
  "aboutUsPage",

  async (payload, { rejectWithValue, dispatch, getState }) => {
    const details = {
      ...payload,
      withHeaders: true,
    };
    try {
      let url = "";
      if (details) {
        url = `${LANDING_PAGE_URL}/${payload.slug}`;
      }
      let res = await API.get(details)(url, details);
      return { aboutUs: res?.data.response.data, status: true };
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export default aboutUsPage;
